import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CBLSelectionComponent } from './cblselection/cblselection.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppDirectivesModule } from '../../app-derectives/app-derectives.module';
import { AddRefreshModule } from '../add-refresh/add-refresh.module';
import { PartyCBLComponent } from './party-cbl/party-cbl.component';

@NgModule({
  declarations: [CBLSelectionComponent, PartyCBLComponent],
  exports: [CBLSelectionComponent, PartyCBLComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    NgSelectModule,
    AppDirectivesModule,
    AddRefreshModule,
  ],
  entryComponents: [CBLSelectionComponent],
})
export class CompanyBranchLocationModule {}
